export const ApiErrorCode = {
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
    ACCOUNT_INACTIVE: 'ACCOUNT_INACTIVE',
    UNAUTHENTICATED: 'UNAUTHENTICATED',
    FORBIDDEN: 'FORBIDDEN',
    NOT_FOUND: 'NOT_FOUND',
    CONFLICT: 'CONFLICT',
    PERIOD_CLOSED: 'PERIOD_CLOSED',
    /**
     * Falta aceitar o Termo de Uso ou o Manual. O front reage abrindo a tela de
     * aceite em vez de mostrar "acesso negado" — é bloqueio de fluxo, não de
     * permissão.
     */
    ACCEPTANCE_REQUIRED: 'ACCEPTANCE_REQUIRED',
    RATE_LIMITED: 'RATE_LIMITED',
    PAYLOAD_TOO_LARGE: 'PAYLOAD_TOO_LARGE',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
};
/**
 * Política de senha, definida uma vez e usada nos dois lados: o `server` valida
 * e o `web` exibe as regras. Divergir aqui é como o usuário descobre a regra
 * levando erro do servidor.
 */
export const PASSWORD_POLICY = {
    minLength: 10,
    maxLength: 128,
    requireLowercase: true,
    requireUppercase: true,
    requireDigit: true,
};
export const PASSWORD_POLICY_HINT = 'Mínimo de 10 caracteres, com ao menos uma letra maiúscula, uma minúscula e um número.';
export function describePasswordViolations(password) {
    const problems = [];
    if (password.length < PASSWORD_POLICY.minLength) {
        problems.push(`Use pelo menos ${PASSWORD_POLICY.minLength} caracteres.`);
    }
    if (password.length > PASSWORD_POLICY.maxLength) {
        problems.push(`Use no máximo ${PASSWORD_POLICY.maxLength} caracteres.`);
    }
    if (PASSWORD_POLICY.requireLowercase && !/[a-z]/.test(password)) {
        problems.push('Inclua ao menos uma letra minúscula.');
    }
    if (PASSWORD_POLICY.requireUppercase && !/[A-Z]/.test(password)) {
        problems.push('Inclua ao menos uma letra maiúscula.');
    }
    if (PASSWORD_POLICY.requireDigit && !/[0-9]/.test(password)) {
        problems.push('Inclua ao menos um número.');
    }
    return problems;
}
//# sourceMappingURL=api.js.map